var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuStatisticButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1413 20.191H20.9711V4.19827C20.9711 3.55466 20.4445 3.02808 19.8009 3.02808H16.6803C16.0367 3.02808 15.5101 3.55466 15.5101 4.19827V20.191H14.73V9.65919C14.73 9.01558 14.2034 8.489 13.5598 8.489H10.4393C9.79568 8.489 9.26909 9.01558 9.26909 9.65919V20.191H8.48896V15.1201C8.48896 14.4765 7.96237 13.9499 7.31876 13.9499H4.19823C3.55462 13.9499 3.02804 14.4765 3.02804 15.1201V20.191H1.85784C1.6433 20.191 1.46777 20.3665 1.46777 20.581C1.46777 20.7956 1.6433 20.9711 1.85784 20.9711H22.1413C22.3558 20.9711 22.5313 20.7956 22.5313 20.581C22.5313 20.3665 22.3558 20.191 22.1413 20.191ZM7.70882 20.191H3.80817V15.1201C3.80817 14.9056 3.9837 14.73 4.19823 14.73H7.31876C7.53329 14.73 7.70882 14.9056 7.70882 15.1201V20.191ZM13.9499 20.191H10.0492V9.65919C10.0492 9.44466 10.2247 9.26913 10.4393 9.26913H13.5598C13.7743 9.26913 13.9499 9.44466 13.9499 9.65919V20.191ZM20.1909 20.191H16.2903V4.19827C16.2903 3.98374 16.4658 3.80821 16.6803 3.80821H19.8009C20.0154 3.80821 20.1909 3.98374 20.1909 4.19827V20.191Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatisticButton);
export default __webpack_public_path__ + "static/media/MenuStatisticButton.7af12809.svg";
export { ForwardRef as ReactComponent };